module.exports = __webpack_public_path__ + "img/139353-202907-1753@2x.72dff933.png";